class YKCrossSellPopup extends HTMLElement {
  constructor() {
    super();
    this._delayTimer = null;
    this._delayShowHandler = null;

    this.bundleKey = 'bundle';
    this.pendingTtlMs = 15 * 60 * 1000;

    this._listenersBound = false;
    this._submitting = false;
    this._currentKey = null;
    this._acceptedNow = false;
    this._ctaMounted = false;
    this._lastExpireAt = 0;
    this._countdowns = new Map();
    this._ctaTimerEl = null;

    this._onModalInteract = this._onModalInteract.bind(this);
    this._onKeyDown = this._onKeyDown.bind(this);

    this.innerHTML = `
    <div id="cross-sell-popup-modal" class="flex-col" role="dialog" aria-modal="true">
      <div class="text-s text-white h-11 mb-[-10px] rounded-t-2xl w-full max-w-[375px] bg-pink100 flex pt-2 relative">
        <p class="font-semibold tracking-[0.38px]" data-header-copy>Oferta dostępna w koszyku przez</p>
        <div class="flex items-start gap-1.5 ml-1.5 mr-1" data-timer-wrap>
          <img
              class="object-contain"
              src="https://cdn.shopify.com/s/files/1/0593/6902/9684/files/clock-01.png?v=1757671862"
              alt=""
              width="19"
              height="18"
          >
          <span class="" data-xsell-timer></span>
        </div>
        <span id="cross-sell-popup-close" class="modal-close cursor-pointer ml-auto mr-4 mt-1 absolute right-0 w-5 h-5 flex justify-end items-start">
          <img src="https://cdn.shopify.com/s/files/1/0593/6902/9684/files/icon-white-close.png?v=1757495524" width="12" height="12">
        </span>
      </div>
      <div class="modal-content bg-[#F5F5F5] max-w-[375px] relative flex flex-col center justify-center rounded-xl w-full">
          <div class="rounded-t-lg" id="cross-sell-popup-body"></div>
      </div>
    </div>
    `;

    this._onReadyHandler = () => setTimeout(() => this._onSmartcartReady(), 0);
  }

  connectedCallback() {
    this.$modal = this.querySelector('#cross-sell-popup-modal');
    this.$body = this.querySelector('#cross-sell-popup-body');
    this._cfg = this._readConfig?.() || {};

    this._installCloseHandlers();

    this.$body.addEventListener('click', (e) => this._handlePopupClicks(e));

    if (!this._listenersBound) this.setListeners();

    try {
      this._armRedirectWatcher();
    } catch (_) {}
  }

  disconnectedCallback() {
    this._removeCloseHandlers();

    document.removeEventListener('rebuy:smartcart.show', this._onReadyHandler);
    document.removeEventListener('rebuy:cart.enriched', this._onReadyHandler);
    this._listenersBound = false;

    if (this._timerId) {
      clearInterval(this._timerId);
      this._timerId = null;
    }
    if (this._mo) {
      this._mo.disconnect();
      this._mo = null;
    }
    if (this._ctaBtn && this._ctaHandler) {
      this._ctaBtn.removeEventListener('click', this._ctaHandler);
      this._ctaBtn = null;
      this._ctaHandler = null;
    }

    this._clearAllCountdowns();

    if (this._delayTimer) {
      clearTimeout(this._delayTimer);
      this._delayTimer = null;
    }
    if (this._delayShowHandler) {
      document.removeEventListener('rebuy:smartcart.hide', this._delayShowHandler);
      this._delayShowHandler = null;
    }
  }

  _installCloseHandlers() {
    if (!this.$modal) return;

    this.$modal.addEventListener('click', this._onModalInteract, { passive: false });
    this.$modal.addEventListener('touchend', this._onModalInteract, { passive: false });
    document.addEventListener('keydown', this._onKeyDown);

    const closeEl = this.querySelector('#cross-sell-popup-close');
    if (closeEl) {
      closeEl.setAttribute('role', 'button');
      closeEl.setAttribute('tabindex', '0');
    }
  }

  _removeCloseHandlers() {
    if (this.$modal) {
      this.$modal.removeEventListener('click', this._onModalInteract);
      this.$modal.removeEventListener('touchend', this._onModalInteract);
    }
    document.removeEventListener('keydown', this._onKeyDown);
  }
  _onModalInteract(evt) {
    const isOverlayClick = evt.target === this.$modal || !this.$body.contains(evt.target);

    const closeBtn = evt.target.closest?.('#cross-sell-popup-close');

    if (isOverlayClick || closeBtn) {
      evt.preventDefault();
      this.hide();

      const origin = closeBtn ? 'close_button' : 'overlay';
      Promise.resolve(this._pushCloseEvent?.(origin)).catch(() => {});
    }
  }

  _onKeyDown(e) {
    if (e.key === 'Escape') this.hide();
    if ((e.key === 'Enter' || e.key === ' ') && e.target?.id === 'cross-sell-popup-close') {
      e.preventDefault();
      this.hide();
      Promise.resolve(this._pushCloseEvent?.('close_button')).catch(() => {});
    }
  }

  _installCloseHandlers() {
    if (!this.$modal) return;

    this.$modal.addEventListener('click', this._onModalInteract, { passive: false });
    this.$modal.addEventListener('touchend', this._onModalInteract, { passive: false });
    document.addEventListener('keydown', this._onKeyDown);

    const closeEl = this.querySelector('#cross-sell-popup-close');
    if (closeEl) {
      closeEl.setAttribute('role', 'button');
      closeEl.setAttribute('tabindex', '0');
    }
  }

  _removeCloseHandlers() {
    if (this.$modal) {
      this.$modal.removeEventListener('click', this._onModalInteract);
      this.$modal.removeEventListener('touchend', this._onModalInteract);
    }
    document.removeEventListener('keydown', this._onKeyDown);
  }
  _onModalInteract(evt) {
    const isOverlayClick = evt.target === this.$modal || !this.$body.contains(evt.target);

    const closeBtn = evt.target.closest?.('#cross-sell-popup-close');

    if (isOverlayClick || closeBtn) {
      evt.preventDefault();
      this.hide();

      const origin = closeBtn ? 'close_button' : 'overlay';
      Promise.resolve(this._pushCloseEvent?.(origin)).catch(() => {});
    }
  }

  _onKeyDown(e) {
    if (e.key === 'Escape') this.hide();
    if ((e.key === 'Enter' || e.key === ' ') && e.target?.id === 'cross-sell-popup-close') {
      e.preventDefault();
      this.hide();
      Promise.resolve(this._pushCloseEvent?.('close_button')).catch(() => {});
    }
  }

  async setCartPopupTrigger(formEl) {
    try {
      if (this._isHardClosed()) return;

      const cfgKeyRaw = this._cfg && typeof this._cfg.key === 'string' ? this._cfg.key : '';
      const cfgKey = cfgKeyRaw.trim().toLowerCase();

      const btn =
        formEl?.querySelector('[type="submit"][data-cross-sell-keys]') ||
        document.querySelector('[data-cross-sell-keys]');
      const btnKey = btn?.getAttribute('data-cross-sell-keys')?.trim().toLowerCase() || '';

      const rawKey = cfgKey || btnKey;
      if (!rawKey) return;

      const srcId = formEl?.querySelector('input[name="id"]')?.value;
      this._sourceVariantId = srcId ? Number(srcId) : null;

      const items = window.Rebuy?.SmartCart?.cart?.items || [];
      const triggerVid = Number(this._sourceVariantId || 0);

      const nonPromoTriggerQty = items
        .filter((it) => !(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1'))
        .reduce(
          (n, it) =>
            n +
            (Number(it?.variant_id ?? it?.product_variant_id ?? it?.variant?.id ?? 0) === triggerVid
              ? Number(it.quantity || 1)
              : 0),
          0
        );

      const hasLinkedPromoInCart = items.some((it) => Number(it?.properties?._yk_xsell_link || 0) === triggerVid);

      const lastKey = (localStorage.getItem('yk_xsell_groupB_lastkey') || '').toLowerCase().trim();
      const exp = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      const notExpired = Number.isFinite(exp) && Date.now() < exp;
      const sameKey = lastKey === rawKey.toLowerCase().trim();

      if (hasLinkedPromoInCart) return;

      if (nonPromoTriggerQty >= 1) return;

      if (this._shouldSuppressForCart(triggerVid, { key: rawKey })) return;

      if (sameKey && !notExpired) return;

      this._scheduleDelayedPopupForKey(rawKey, 5000);
    } catch (e) {
      console.warn('setCartPopupTrigger error', e);
    }
  }

  setListeners() {
    if (this._listenersBound) return;

    const smartCartRoot = document.getElementById('rebuy-cart') || document.body;

    document.addEventListener('rebuy:smartcart.show', this._onReadyHandler);
    document.addEventListener('rebuy:cart.enriched', this._onReadyHandler);

    if (!this._mo) {
      this._mo = new MutationObserver(() => {
        if (!this._ctaMounted && document.getElementById('yk-xsell-pending-cta')) {
          this._onSmartcartReady();
        }
      });
      this._mo.observe(smartCartRoot, { childList: true, subtree: true });
    }

    this._listenersBound = true;
  }

  _shouldSuppressForCart(triggerVid, opts = {}) {
    try {
      const items = window.Rebuy?.SmartCart?.cart?.items || [];
      const vId = Number(triggerVid || 0);
      const fromCart = opts.fromCart === true;
      const curKey = String(opts.key || '')
        .toLowerCase()
        .trim();

      const hasAnyPromo = items.some(
        (it) => it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1'
      );
      if (hasAnyPromo) return true;

      const triggerItem = items.find((it) => {
        const isPromo = !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
        if (isPromo) return false;
        const v = Number(it?.variant_id ?? it?.product_variant_id ?? it?.variant?.id ?? 0);
        return Number.isFinite(v) && v > 0 && v === vId;
      });

      const triggerProductId = Number(triggerItem?.product_id || triggerItem?.product?.id || 0);

      if (!fromCart && Number.isFinite(triggerProductId) && triggerProductId > 0) {
        const hasSameProductOtherVariant = items.some((it) => {
          const isPromo = !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
          if (isPromo) return false;

          const pid = Number(it?.product_id || it?.product?.id || 0);
          if (!Number.isFinite(pid) || pid !== triggerProductId) return false;

          const v = Number(it?.variant_id ?? it?.product_variant_id ?? it?.variant?.id ?? 0);

          return Number.isFinite(v) && v > 0 && v !== vId;
        });

        if (hasSameProductOtherVariant) return true;
      }

      let hasOtherTrigger =
        !fromCart &&
        items.some((it) => {
          const isPromo = !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
          if (isPromo) return false;
          const v = Number(it?.variant_id ?? it?.product_variant_id ?? it?.variant?.id ?? 0);
          return Number.isFinite(v) && v > 0 && v !== vId;
        });

      if (hasOtherTrigger) {
        try {
          const lastKey = (localStorage.getItem('yk_xsell_groupB_lastkey') || '').toLowerCase().trim();
          if (curKey && lastKey && curKey === lastKey) {
            hasOtherTrigger = false;
          }
        } catch (_) {}
        if (hasOtherTrigger) return true;
      }

      return false;
    } catch (_) {
      return false;
    }
  }

  _isHardClosed() {
    const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const expRaw = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    const hasExp = Number.isFinite(expRaw) && expRaw > 0;
    const expired = hasExp ? Date.now() >= expRaw : true;
    return shown && !pending && expired;
  }

  _onSmartcartReady() {
    if (this._isHardClosed()) {
      this._expireGroupB();
      return;
    }

    const ctaWrap = document.getElementById('yk-xsell-pending-cta');
    const btn = document.getElementById('yk-xsell-open-from-cart');
    const timerEl = document.getElementById('yk-xsell-timer');

    if (!ctaWrap || !btn) return;

    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const lastKey = localStorage.getItem('yk_xsell_groupB_lastkey') || '';
    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    const triggerVid = Number(localStorage.getItem('yk_xsell_groupB_link') || 0);

    if (!pending || !lastKey || !expireAt) return;

    if (Date.now() >= expireAt) {
      this._expireGroupB();
      return;
    }

    ctaWrap.style.removeProperty('display');
    ctaWrap.classList.remove('hidden');

    if (Number.isFinite(triggerVid) && triggerVid > 0) {
      ctaWrap.setAttribute('data-trigger-vid', String(triggerVid));
    }

    if (timerEl) {
      if (this._ctaTimerEl && this._ctaTimerEl !== timerEl) {
        this._stopCountdownFor(this._ctaTimerEl);
      }
      this._ctaTimerEl = timerEl;
      this._stopCountdownFor(timerEl);

      this._startCountdown(timerEl, expireAt, () => {
        ctaWrap.style.display = 'none';
        this._expireGroupB();
      });
    }

    if (this._ctaBtn !== btn) {
      this._ctaBtn?.removeEventListener?.('click', this._ctaHandler);
      this._ctaHandler = () => {
        try {
          this._pushCartCtaEvent();
        } catch (_) {}
        try {
          localStorage.setItem('yk_xsell_opened_from_cart', '1');
        } catch (_) {}
        this.openWithKey(lastKey, { force: true, fromCart: true });
      };
      btn.addEventListener('click', this._ctaHandler);
      this._ctaBtn = btn;
    }

    this._ctaMounted = true;
    this._lastExpireAt = expireAt;
  }

  _getStoredGroupBItems() {
    try {
      const arr = JSON.parse(localStorage.getItem('yk_xsell_groupB_items') || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  }

  show(nodeOrHTML) {
    if (this.$modal.classList.contains('active')) return;
    try {
      this._clearRedirectSchedule();
    } catch (_) {}
    try {
      _clearReopenMode();
    } catch (_) {}

    this.$body.innerHTML = '';
    if (typeof nodeOrHTML === 'string') this.$body.innerHTML = nodeOrHTML;
    else if (nodeOrHTML instanceof Node) this.$body.appendChild(nodeOrHTML);

    this.$modal.classList.add('active');
    document.body.classList.add('popup-shown');

    try {
      this._pushViewEvent();
    } catch (_) {}

    const popupTimerEl = document.querySelector('[data-xsell-timer]');
    if (popupTimerEl) {
      if (this._currentKey === this.bundleKey) {
        popupTimerEl.textContent = '';
        return;
      }

      const expireAt = this._getPendingExpireAt();
      if (expireAt) {
        this._stopCountdownFor(popupTimerEl);
        this._startCountdown(popupTimerEl, expireAt, () => {
          this.hide();
          this._expireGroupB();
        });
      } else {
        popupTimerEl.textContent = '';
      }
    }
  }

  hide() {
    this._cancelDelayedPopup();

    if (this._currentKey && this._currentKey !== this.bundleKey && !this._acceptedNow) {
      const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
      const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
      const existingExpire = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      const notExpired = Number.isFinite(existingExpire) && existingExpire > Date.now();

      if (shown && notExpired) {
        localStorage.setItem('yk_xsell_groupB_pending', '1');
        localStorage.removeItem('yk_xsell_groupB_shown');
      } else {
        if (!(pending && notExpired)) {
          this._setGroupBPending(this._currentKey, this.pendingTtlMs);
        }
      }
    }

    this.$modal.classList.remove('active');
    this.$body.innerHTML = '';
    document.body.classList.remove('popup-shown');

    setTimeout(() => {
      Rebuy.SmartCart.show();
    }, 150);

    if (this._currentKey === this.bundleKey) {
      this._markShown(this.bundleKey);
    } else if (this._acceptedNow && this._currentKey) {
      this._markShown(this._currentKey);

      const cart = document.getElementById('rebuy-cart');
      if (cart && cart.classList.contains('is-visible')) {
        this._onSmartcartReady();
      }

      this._acceptedNow = false;
      this._currentKey = null;
    }

    if (this._resolveWait) {
      this._resolveWait();
      this._resolveWait = null;
    }
  }

  openWithTemplateId(templateId) {
    const node = this._cloneFromDOM(templateId);
    if (node) this.show(node);
  }

  _readConfig() {
    try {
      const el = document.getElementById('yk-xsell-config');
      if (!el) return null;
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  }

  _cancelDelayedPopup() {
    if (this._delayTimer) {
      clearTimeout(this._delayTimer);
      this._delayTimer = null;
    }
    if (this._delayShowHandler) {
      document.removeEventListener('rebuy:smartcart.hide', this._delayShowHandler);
      this._delayShowHandler = null;
    }
  }

  _getActiveOffer() {
    const lastKey = (localStorage.getItem('yk_xsell_groupB_lastkey') || '').toLowerCase().trim();
    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
    const notExpired = Number.isFinite(expireAt) && Date.now() < expireAt;
    return { lastKey, expireAt, pending, shown, notExpired };
  }

  _hasTriggerInCart(variantId) {
    try {
      const vId = Number(variantId || 0);
      if (!Number.isFinite(vId) || vId <= 0) return false;

      const items = window.Rebuy?.SmartCart?.cart?.items || [];
      return items.some((it) => {
        const isPromo = !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
        if (isPromo) return false;
        const v = Number(it?.variant_id ?? it?.product_variant_id ?? it?.variant?.id ?? 0);
        return Number.isFinite(v) && v > 0 && v === vId;
      });
    } catch (_) {
      return false;
    }
  }

  _scheduleDelayedPopupForKey(key, delayMs = 5000) {
    if (!key) return;

    if (this._scheduledKey === key) return;
    this._scheduledKey = key;

    this._cancelDelayedPopup();

    const getPlannedTriggerVid = () => {
      return Number(this._sourceVariantId || localStorage.getItem('yk_xsell_groupB_link') || 0);
    };

    const showNow = () => {
      this._cancelDelayedPopup();
      if (this._isHardClosed()) return;

      const { pending, shown, notExpired, lastKey } = this._getActiveOffer();

      if (pending && notExpired) return;

      if ((pending || shown) && notExpired && lastKey && lastKey !== key.toLowerCase().trim()) return;

      const linkVid = getPlannedTriggerVid();

      if (!this._hasTriggerInCart(linkVid)) return;

      if (this._shouldSuppressForCart(linkVid, { fromCart: false, key })) return;

      this.openWithKey(key);

      this._scheduledKey = null;
    };

    this._delayShowHandler = () => showNow();
    document.addEventListener('rebuy:smartcart.hide', this._delayShowHandler, { once: true });

    this._delayTimer = setTimeout(showNow, delayMs);
  }

  openWithKey(rawKey, opts = {}) {
    if (this._isHardClosed()) return;

    this._cancelDelayedPopup();
    const key = String(rawKey || '')
      .toLowerCase()
      .trim();
    const force = opts.force === true;

    try {
      if (!opts.fromCart) {
        const { pending, shown, notExpired, lastKey } = this._getActiveOffer();
        if ((pending || shown) && notExpired && lastKey && lastKey !== key) {
          return;
        }
      }

      const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
      const lastKey = (localStorage.getItem('yk_xsell_groupB_lastkey') || '').toLowerCase().trim();
      const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      const notExpired = Number.isFinite(expireAt) && Date.now() < expireAt;

      const triggerVid = Number(
        (opts.fromCart ? localStorage.getItem('yk_xsell_groupB_link') : this._sourceVariantId) ||
          localStorage.getItem('yk_xsell_groupB_link') ||
          0
      );
      if (opts.fromCart === true && Number.isFinite(triggerVid) && triggerVid > 0) {
        this._sourceVariantId = triggerVid;
      }

      const items = window.Rebuy?.SmartCart?.cart?.items || [];
      const hasLinkedPromoInCart = items.some((it) => Number(it?.properties?._yk_xsell_link || 0) === triggerVid);

      if (opts.fromCart === true) {
        const hasAnyPromo = items.some(
          (it) => it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1'
        );
        if (hasAnyPromo) return;
      } else {
        if (this._shouldSuppressForCart(triggerVid, { fromCart: false, key })) return;
      }

      if (force && shown && notExpired && lastKey === key && hasLinkedPromoInCart && !opts.fromCart) {
        return;
      }
    } catch (_) {}

    if (!force && !this._canShow(key)) return;
    this._cfg = this._readConfig?.() || {};
    this._currentKey = key;

    if (key === this.bundleKey) {
      if (!localStorage.getItem(this._keyFlag(this.bundleKey))) {
        localStorage.setItem(this._keyFlag(this.bundleKey), '1');
        try {
          localStorage.setItem('yk_xsell_key_bundle_ts', String(Date.now()));
        } catch (_) {}
      }
      this._applyHeaderVariant(this.bundleKey);

      const html = this._renderBundleMarkup();
      this.show(html);
      return;
    }

    if (!this._getPendingExpireAt()) {
      const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
      const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      if (!(shown && Number.isFinite(expireAt) && Date.now() < expireAt)) {
        this._setGroupBPending(key, this.pendingTtlMs);
      }
    }

    this._applyHeaderVariant('default');

    const isFromCart = opts.fromCart === true;
    const isPending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const stored = this._getStoredGroupBItems();

    if ((isFromCart || isPending) && stored.length) {
      this._renderGroupBItems(stored);
      return;
    }

    const seed = this._readSeed?.();
    if (Array.isArray(seed) && seed.length) {
      if (!stored.length) this._storeGroupBItems(seed);
      this._renderGroupBItems(seed);
      return;
    }

    if (Array.isArray(stored) && stored.length) {
      this._renderGroupBItems(stored);
      return;
    }

    this.openWithTemplateId('popup-groupb-products');
  }

  _renderBundleMarkup() {
    return `
    <div class="flex flex-col items-center p-[30px] text-center relative">
      <div class="font-light font-serif text-[24px] relative w-[78%]">
        <span class="block">Skonfiguruj własny zestaw </span>
        <div class="flex items-center justify-center">
        <span>i zgarnij aż</span>
        <span class="badge-discount inline-block px-2 py-0.5 h-[18px] ml-1 mr-1 mb-[-5px] leading-[13px] rounded font-sans text-white font-semibold text-xs bg-pink100">-25%</span>
        <span class="block">zniżki</span>
        </div>
      </div>
      <h4 class="text-s w-[60%] tracking-[0.38px] font-semibold mt-3">Wybieraj spośród wszystkich produktów makeup</h4>
      <div class="w-[183px] h-[187px] mt-5">
        <img
          src="https://cdn.shopify.com/s/files/1/0593/6902/9684/files/jpeg-optimizer_960x1200_zestaw_2_1_28033409-7340-4851-8235-c41970e22d29.jpg?v=1757671224"
          alt="Zestaw -25%"
          width="320" height="400"
          class="w-full h-full object-cover object-center rounded-lg "
          loading="lazy"
        >
      </div>
      <a id="yk-create-bundle" href="https://yourkaya.pl/products/bundle-makeup" class="btn btn--primary-2 pl-2.5 pr-2.5 h-[30px] max-w-[183px] w-full tracking-[0.8px] mt-[30px]">
        Stwórz swój zestaw
      </a>
    </div>
  `;
  }

  markAccepted() {
    this._acceptedNow = true;
    this._cancelDelayedPopup();

    localStorage.setItem('yk_xsell_groupB_shown', '1');
    localStorage.setItem('yk_xsell_groupB_shown_ts', String(Date.now()));

    localStorage.removeItem('yk_xsell_groupB_pending');

    this._hideCartCtaNow();

    this._ctaMounted = false;
    this._lastExpireAt = 0;
  }

  _canShow(key) {
    if (!key) return false;

    if (key === this.bundleKey) {
      return !localStorage.getItem(this._keyFlag(this.bundleKey));
    }

    if (localStorage.getItem('yk_xsell_groupB_shown') === '1') {
      const lastKey = localStorage.getItem('yk_xsell_groupB_lastkey') || '';
      const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      if (lastKey === key && Number.isFinite(expireAt) && Date.now() < expireAt) {
        return true;
      }
      return false;
    }

    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);

    if (pending) {
      if (Date.now() < expireAt) return false;

      this._expireGroupB();
      return false;
    }

    return true;
  }

  _markShown(key) {
    if (!key) return;
    if (key === this.bundleKey) {
      localStorage.setItem(this._keyFlag(this.bundleKey), '1');
      try {
        localStorage.setItem('yk_xsell_key_bundle_ts', String(Date.now()));
      } catch (_) {}
    } else {
      localStorage.setItem('yk_xsell_groupB_shown', '1');
      localStorage.setItem('yk_xsell_groupB_shown_ts', String(Date.now()));
      localStorage.removeItem('yk_xsell_groupB_pending');
    }
  }

  _setGroupBPending(key, ttlMs) {
    const expireAt = Date.now() + (ttlMs || 0);

    localStorage.setItem('yk_xsell_groupB_pending', '1');
    localStorage.setItem('yk_xsell_groupB_lastkey', key);
    localStorage.setItem('yk_xsell_groupB_expire_at', String(expireAt));
    if (this._sourceVariantId) {
      localStorage.setItem('yk_xsell_groupB_link', String(this._sourceVariantId));
    }

    try {
      const cfg = this._cfg || {};
      const a = (cfg.subtitle_offer_a || '').trim();
      const b = (cfg.subtitle_offer_b || '').trim();
      // zapisujemy zawsze przy wejściu w pending – to „źródłowe” brzmienie dla tego key
      this._storeGroupBSubtitles(key, a, b);
    } catch (_) {}
  }

  _expireGroupB() {
    localStorage.removeItem('yk_xsell_groupB_pending');
    localStorage.removeItem('yk_xsell_groupB_lastkey');
    localStorage.removeItem('yk_xsell_groupB_expire_at');
    localStorage.removeItem('yk_xsell_groupB_items');
    localStorage.removeItem('yk_xsell_groupB_link');
    localStorage.setItem('yk_xsell_groupB_shown', '1');
    const existingTs = Number(localStorage.getItem('yk_xsell_groupB_shown_ts') || 0);
    const hasValidTs = Number.isFinite(existingTs) && existingTs > 0;
    if (!hasValidTs) {
      localStorage.setItem('yk_xsell_groupB_shown_ts', String(Date.now()));
    }
    localStorage.removeItem('yk_xsell_opened_from_cart');
    localStorage.removeItem('yk_xsell_groupB_subtitles');
    this._ctaMounted = false;
    this._lastExpireAt = 0;
  }

  _keyFlag(key) {
    return `yk_xsell_key_${key}`;
  }

  _readSeed() {
    try {
      const el = document.getElementById('yk-xsell-seed');
      if (!el) return null;
      return JSON.parse(el.textContent || '[]');
    } catch (_) {
      console.log('_');
      return null;
    }
  }

  _storeGroupBItems(items) {
    if (Array.isArray(items) && items.length) {
      localStorage.setItem('yk_xsell_groupB_items', JSON.stringify(items));
    }
  }

  _splitTitle = (title) => {
    const m = title.match(/\s*(-\d+%)$/);
    if (m) {
      return {
        base: title.replace(/\s*-\d+%$/, ''),
        discount: m[1],
      };
    }
    return { base: title, discount: '' };
  };

  _storeGroupBSubtitles(key, a, b) {
    try {
      const rec = {
        key: String(key || '')
          .toLowerCase()
          .trim(),
        a: typeof a === 'string' ? a : '',
        b: typeof b === 'string' ? b : '',
      };
      localStorage.setItem('yk_xsell_groupB_subtitles', JSON.stringify(rec));
    } catch (_) {}
  }

  _readGroupBSubtitles() {
    try {
      const raw = localStorage.getItem('yk_xsell_groupB_subtitles');
      if (!raw) return null;
      const rec = JSON.parse(raw);
      if (!rec || typeof rec !== 'object') return null;
      return {
        key: String(rec.key || '')
          .toLowerCase()
          .trim(),
        a: rec.a || '',
        b: rec.b || '',
      };
    } catch (_) {
      return null;
    }
  }

  _renderGroupBItems(items) {
    this.openWithTemplateId('popup-groupb-products');

    const grid = this.$body.querySelector('#yk-xsell-grid');
    if (!grid) return;

    if (!Array.isArray(items) || items.length < 1) {
      grid.innerHTML = '<p>Brak zdefiniowanych produktów w metafieldzie.</p>';
      return;
    }

    const fmt = (cents) => (cents / 100).toFixed(2).replace('.', ',') + ' zł';

    const prod1 = items[0];
    const prod2 = items[1];

    const t1 = this._splitTitle(prod1.title);
    const t2 = prod2 ? this._splitTitle(prod2.title) : { base: '', discount: '' };

    const renderDropdown = (product, idx, selectedId) => {
      if (!product.variants || product.variants.length <= 1) return '';
      return `
      <div class="xs-variants cursor-pointer mt-auto">
        <select class="xs-variant-select w-full border px-3 py-2 rounded"
                data-product-index="${idx}">
           ${product.variants
             .map((v) => {
               const selected = Number(v.id) === Number(selectedId) ? 'selected' : '';

               return `<option
                   value="${v.id}"
                   ${selected}
                   data-price-cents="${Number(v.price || 0)}"
                   data-compare-at-price-cents="${Number(product.compare_at_price || 0)}"
                   data-image-src="${(v.image || product.image || '').replace(/"/g, '&quot;')}"
                 >${v.title || v.name || 'Wariant'}</option>`;
             })
             .join('')}
        </select>
      </div>
    `;
    };

    const cfg = this._cfg || {};

    const savedSubs = this._readGroupBSubtitles();
    const lastKey = (localStorage.getItem('yk_xsell_groupB_lastkey') || '').toLowerCase().trim();
    const subsMatch = savedSubs && savedSubs.key === lastKey;

    const subtitleA =
      (subsMatch && savedSubs.a) || (cfg.subtitle_offer_a || '').trim() || 'Dokończ swoją rutynę z wyjątkową ceną';

    const subtitleB =
      (subsMatch && savedSubs.b) || (cfg.subtitle_offer_b || '').trim() || 'Teraz albo wcale – wypróbuj zestaw';

    const l1 = (items?.[0]?.label || '').trim();
    const l2 = (items?.[1]?.label || '').trim();

    const r1 = prod1?.url || '';
    const r2 = prod2?.url || '';

    const offerA = `
    <div class="xs-offer p-3 mb-3 bg-bg-white rounded-lg">
      <h4 class="font-semibold text-s text-center mb-3">${subtitleA}</h4>
      <div class="flex gap-3">
          <a data-xsell-redirect="0" href="${r1}" class="relative block flex-1 min-w-[153.5px] h-[153.5px]">
            <img src="${prod1.image}" alt="${prod1.title}" class="object-cover h-full w-full rounded-sm" data-xsell-image="0">
            <div class="badge-discount absolute top-2 left-2 px-2 py-0.5 rounded-3xl text-white font-semibold text-xs bg-pink100">${l1}</div>
          </a>
          <div class="flex flex-col flex-1">
            <div class="title text-s font-medium mb-2">${t1.base}</div>
            <div class="flex font-semibold">
              <div class="price text-pink100 text-s">${fmt(prod1.price)}</div>
              <div class="compare_at_price text-s text-gray60 line-through ml-[6px]">${fmt(prod1.compare_at_price)}</div>
            </div>
            ${renderDropdown(prod1, 0, prod1.variant_id)}
            <button
              type="button"
              class="x-sell-btn btn btn--primary-2 mt-2 text-[11px] !normal-case h-[30px] !px-0 rounded-sm"
              data-popup-add-to-cart
              data-variant-id="${prod1.variant_id}"
              data-compare_at_price="${prod1.compare_at_price || ''}"
              data-qty="1"
              data-product-index="0"
            >
              DODAJ ${fmt(prod1.price)}
            </button>
        </div>
      </div>
    </div>
  `;

    let offerB = '';
    if (prod2) {
      const itemsJSON = JSON.stringify([
        {
          id: Number(prod1.variant_id),
          quantity: 1,
          compare_at_price: Number(prod1.compare_at_price || 0),
        },
        {
          id: Number(prod2.variant_id),
          quantity: 1,
          compare_at_price: Number(prod2.compare_at_price || 0),
        },
      ]);
      offerB = `
      <div class="xs-offer p-3 rounded-lg bg-bg-white ">
        <h4 class="font-semibold text-s text-center mb-3">${subtitleB}</h4>
        <div class="flex gap-7 mb-3 relative">
          <div class="xs-card flex-1 flex flex-col">
            <a data-xsell-redirect="0" href="${r1}" class="block relative h-[153.5px] w-[145.5px] mb-3">
              <img src="${prod1.image}" alt="${prod1.title}" class="h-full w-full object-cover rounded-sm" data-xsell-image="1">
               <div class="badge-discount absolute top-2 left-2 px-2 py-0.5 rounded-3xl text-white font-semibold text-xs bg-pink100">${l1}</div>
            </a>
              
              <div class="title mb-2 text-s tracking-[0.38px]">${t1.base}</div>
              <div class="xs-price flex tracking-[0.38px] font-semibold">
                <div class="price text-pink100 text-s">${fmt(prod1.price)}</div>
                <div class="compare_at_price text-gray60 line-through text-s ml-[6px]">${fmt(prod1.compare_at_price)}</div>
              </div>
            ${renderDropdown(prod1, 1, prod1.variant_id)}
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus absolute left-1/2 top-[70px] -translate-x-1/2 -translate-y-1/2" width="12" height="12" viewBox="0 0 16 16"><path fill-rule="evenodd" fill="#00000" clip-rule="evenodd" d="M8.5 1C8.5 0.723858 8.27614 0.5 8 0.5C7.72386 0.5 7.5 0.723858 7.5 1V7.5H1C0.723858 7.5 0.5 7.72386 0.5 8C0.5 8.27614 0.723858 8.5 1 8.5H7.5L7.5 15C7.5 15.2761 7.72386 15.5 8 15.5C8.27614 15.5 8.5 15.2761 8.5 15V8.5H15C15.2761 8.5 15.5 8.27614 15.5 8C15.5 7.72386 15.2761 7.5 15 7.5H8.5L8.5 1Z" /></svg>
          <div class="xs-card flex-1 flex flex-col">
               <a data-xsell-redirect="1" href="${r2}" class="block relative h-[153.5px] w-[145.5px] mb-3">
                <img src="${prod2.image}" alt="${prod2.title}" class="h-full w-full object-cover rounded-sm" data-xsell-image="2">
               <div class="badge-discount absolute top-2 left-2 px-2 py-0.5 rounded-3xl text-white font-semibold text-xs bg-pink100">${l2}</div>
              </a>
              <div class="title mb-2 text-s tracking-[0.38px]">${t2.base}</div>
              <div class="xs-price flex gap-1 tracking-[0.38px] font-semibold">
                <div class="price text-pink100 text-s">${fmt(prod2.price)}</div>
                <div class="compare_at_price text-gray60 line-through text-s ml-[6px]">${fmt(prod2.compare_at_price)}</div>
              </div>
            ${renderDropdown(prod2, 2, prod2.variant_id)}
          </div>
        </div>
        <button
          type="button"
          class="btn btn--primary-2 h-[30px] !px-0 rounded-sm normal-case w-full text-[11px] ml-[1px] border-[1px]"
          data-popup-add-bundle
          data-items='${itemsJSON}'
          data-product-index="bundle"
        >
          DODAJ ${fmt(prod1.price + prod2.price)}
        </button>
      </div>
    `;
    }

    grid.innerHTML = offerA + offerB;

    this._attachVariantDropdownListeners([prod1, prod2].filter(Boolean));
  }

  _applyHeaderVariant(variant) {
    const $copy = this.$headerCopy || this.querySelector('[data-header-copy]');
    const $wrap = this.$timerWrap || this.querySelector('[data-timer-wrap]');
    const $timer = this.$timerEl || this.querySelector('[data-xsell-timer]');

    if (!$copy) return;

    if (variant === 'bundle') {
      $copy.textContent = 'Twój zestaw makeup czeka na Ciebie!';
      $copy.classList.add('mx-auto');
      $copy.classList.remove('ml-4');

      if ($wrap) $wrap.style.display = 'none';

      if ($timer) $timer.textContent = '';
    } else {
      $copy.textContent = 'Oferta dostępna w koszyku przez';
      $copy.classList.add('ml-4');
      $copy.classList.remove('mx-auto');

      if ($wrap) $wrap.style.removeProperty('display');
    }
  }

  _attachVariantDropdownListeners(products) {
    const selects = this.$body.querySelectorAll('.xs-variant-select');
    if (!selects.length) return;

    selects.forEach((select) => {
      select.addEventListener('change', () => {
        const idx = Number(select.getAttribute('data-product-index'));
        const product = products[idx === 0 ? 0 : idx - 1];
        if (!product) return;

        const variantId = select.value;
        const opt = select.options[select.selectedIndex];
        const compareAtCents = Number(opt?.dataset.compareAtPriceCents || 0);
        const imgSrc = String(opt?.dataset.imageSrc || '');

        if (idx === 0) {
          const btn = this.$body.querySelector('[data-popup-add-to-cart][data-product-index="0"]');
          if (btn) {
            btn.setAttribute('data-variant-id', variantId);

            btn.setAttribute('data-compare_at_price', String(compareAtCents || 0));
          }

          if (imgSrc) {
            const imgEl = this.$body.querySelector('img[data-xsell-image="0"]');
            if (imgEl) imgEl.setAttribute('src', imgSrc);
          }
          return;
        }

        if (idx === 1 || idx === 2) {
          const bundleBtn = this.$body.querySelector('[data-popup-add-bundle]');
          if (!bundleBtn) return;

          let items = [];
          try {
            items = JSON.parse(bundleBtn.getAttribute('data-items') || '[]');
          } catch (_) {}

          if (!Array.isArray(items) || !items.length) return;

          const pos = idx - 1;
          const prev = items[pos] || {};

          items[pos] = {
            ...prev,
            id: Number(variantId),
            quantity: Number(prev.quantity || 1),
            compare_at_price: compareAtCents,
          };

          bundleBtn.setAttribute('data-items', JSON.stringify(items));

          if (imgSrc) {
            const imgIdx = String(idx);
            const imgEl = this.$body.querySelector(`img[data-xsell-image="${imgIdx}"]`);
            if (imgEl) imgEl.setAttribute('src', imgSrc);
          }
        }
      });
    });
  }

  _hideCartCtaNow() {
    try {
      const wrap = document.getElementById('yk-xsell-pending-cta');
      if (wrap) wrap.style.display = 'none';
      if (this._timerId) {
        clearInterval(this._timerId);
        this._timerId = null;
      }
    } catch (_) {}
  }

  _stripDiscountSuffix(title) {
    if (typeof title !== 'string') return '';
    return title.replace(/\s*-\d+%$/, '').trim();
  }

  async _handlePopupClicks(e) {
    const createBundleLink = e.target.closest('#yk-create-bundle');

    const redirectA = e.target.closest('a[data-xsell-redirect]');
    if (redirectA) {
      e.preventDefault();
      try {
        const key = (this._cfg?.key || this._currentKey || '').toLowerCase().trim();
        const fireAt = Date.now() + 30_000;
        localStorage.setItem('yk_xsell_redirect_active', '1');
        localStorage.setItem('yk_xsell_redirect_key', key);
        localStorage.setItem('yk_xsell_redirect_fire_at', String(fireAt));

        localStorage.removeItem('yk_xsell_redirect_suppressed');
      } catch (_) {}

      const href = redirectA.getAttribute('href');
      if (href) window.location.href = href;
      return;
    }

    if (createBundleLink) {
      try {
        e.preventDefault();
        await this._pushBundleCreateClick();
      } catch (_) {}

      const href = createBundleLink.getAttribute('href');
      setTimeout(() => {
        if (href) window.location.href = href;
      }, 500);
      return;
    }

    const singleBtn = e.target.closest('[data-popup-add-to-cart]');

    const bundleBtn = e.target.closest('[data-popup-add-bundle]');

    if (!singleBtn && !bundleBtn) return;

    if (this._submitting) return;
    this._submitting = true;

    const allCtas = this.$body.querySelectorAll('[data-popup-add-to-cart], [data-popup-add-bundle]');
    allCtas.forEach((el) => el.setAttribute('disabled', 'true'));
    const activeBtn = singleBtn || bundleBtn;
    activeBtn.classList.add('is-loading');
    activeBtn.textContent = 'DODANO';

    try {
      const elementValue = singleBtn ? this._getSingleOfferTitle(singleBtn) : this._getBundleOfferTitles();
      this._pushAddEvent(elementValue);
    } catch (_) {}

    try {
      const getSourceLinkId = () => {
        const localLink = Number(localStorage.getItem('yk_xsell_groupB_link') || 0);
        const fromState = Number(this._sourceVariantId || 0);
        return fromState > 0 ? fromState : localLink > 0 ? localLink : 0;
      };

      const storedItems = this._getStoredGroupBItems();
      const l1 = (storedItems?.[0]?.label || '').trim();
      const l2 = (storedItems?.[1]?.label || '').trim();

      const clean1 = this._stripDiscountSuffix(storedItems?.[0]?.title || '');
      const clean2 = this._stripDiscountSuffix(storedItems?.[1]?.title || '');

      let payload;

      if (singleBtn) {
        const variantId = singleBtn.dataset.variantId;
        if (!variantId) throw new Error('Brak data-variant-id na przycisku');
        const compare_at_price = singleBtn.dataset.compare_at_price || null;

        const idx = Number(singleBtn.getAttribute('data-product-index') || 0);
        const label = idx === 0 ? l1 : l2;

        const cleanTitle = idx === 0 ? clean1 : clean2;

        payload = {
          id: Number(variantId),
          quantity: 1,
          properties: {
            _source: 'YK',
            _yk_source: 'YK',
            _widget_id: 'xsell-pop-up',
            _popup_category: this._currentKey,
            _yk_xsell_link: getSourceLinkId() || null,
            _yk_xsell_bundle: '0',
            _yk_xsell_compared_at: compare_at_price,
            ...(label ? { _yk_xsell_label: label } : {}),
            ...(cleanTitle ? { _yk_title_clean: cleanTitle } : {}),
            _redirectTo: storedItems?.[idx]?.url || null,
          },
        };
      } else {
        let items = [];
        try {
          items = JSON.parse(bundleBtn.getAttribute('data-items') || '[]');
        } catch (_) {}
        if (!Array.isArray(items) || items.length === 0) {
          throw new Error('Brak lub błędne data-items na przycisku bundle');
        }

        const bundleGroupId = `bg_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

        payload = {
          items: items.map((it, i) => ({
            id: Number(it.id),
            quantity: Number(it.quantity || 1),
            properties: {
              _source: 'YK',
              _yk_source: 'YK',
              _widget_id: 'xsell-pop-up',
              _popup_category: this._currentKey,
              _yk_xsell_link: getSourceLinkId() || null,
              _yk_xsell_bundle: '1',
              _yk_xsell_compared_at: it.compare_at_price || null,
              _yk_xsell_bundle_group: bundleGroupId,
              ...(i === 0 && l1 ? { _yk_xsell_label: l1 } : {}),
              ...(i === 1 && l2 ? { _yk_xsell_label: l2 } : {}),
              ...(i === 0 && clean1 ? { _yk_title_clean: clean1 } : {}),
              ...(i === 1 && clean2 ? { _yk_title_clean: clean2 } : {}),
              ...(i === 0 ? { _redirectTo: storedItems?.[0]?.url } : {}),
              ...(i === 1 ? { _redirectTo: storedItems?.[1]?.url } : {}),
            },
          })),
        };
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        console.warn('ATC error', err);
        throw new Error('Add to cart failed');
      }

      this.markAccepted();
      _clearReopenMode();
      this.hide();

      if (window.Rebuy?.Cart?.fetchCart) {
        try {
          Rebuy.Cart.fetchCart();
        } catch (_) {}
      }
    } catch (err) {
      console.error(err);

      allCtas.forEach((el) => el.removeAttribute('disabled'));
      activeBtn.classList.remove('is-loading');
    } finally {
      this._submitting = false;
    }
  }

  _cloneFromDOM(id) {
    const el = document.getElementById(id);
    if (!el) return null;
    if ('content' in el) return el.content.cloneNode(true);
    const clone = el.cloneNode(true);
    if (clone.style) clone.style.display = '';
    return clone;
  }

  _getVariantIdFromItem(item) {
    return Number((item && (item.variant_id || item.product_variant_id || (item.variant && item.variant.id))) || 0);
  }

  _getTriggerProductTitle() {
    try {
      const vid = Number(this._sourceVariantId || localStorage.getItem('yk_xsell_groupB_link') || 0);
      if (vid && window.Rebuy?.SmartCart?.cart?.items) {
        const it = (Rebuy.SmartCart.cart.items || []).find((i) => this._getVariantIdFromItem(i) === vid);
        if (it && it.product_title) return String(it.product_title);
      }
    } catch (_) {}

    try {
      if (window.productData?.title) return String(window.productData.title);
    } catch (_) {}

    try {
      const og = document.querySelector('meta[property="og:title"]')?.getAttribute('content');
      if (og) return og;
    } catch (_) {}

    return '';
  }

  _getOfferedProductTitlesList() {
    try {
      const items = this._getStoredGroupBItems();
      if (Array.isArray(items) && items.length) {
        return items
          .map((it) => (it && it.title ? String(it.title) : ''))
          .filter(Boolean)
          .join(', ');
      }
    } catch (_) {}
    return '';
  }

  async _pushCloseEvent(origin) {
    try {
      const sectionTitle = this._getTriggerProductTitle();
      const isBundle = this._currentKey === this.bundleKey;

      if (isBundle) {
        const payload = {
          event: 'cross_sell_popup_makeup_interaction',
          section: sectionTitle || '',
          interaction_type: 'click',
        };
        if (typeof dataLayerPromise === 'function') await dataLayerPromise(payload);
        else window.dataLayer?.push(payload);
        return;
      }

      const offered = this._getOfferedProductTitlesList();
      const payload = {
        event: 'cross_sell_popup_integration',
        section: sectionTitle || '',
        element: origin === 'close_button' ? 'close_button' : 'close_button',
        element_value: offered || '',
        interaction_type: 'click',
      };
      if (typeof dataLayerPromise === 'function') await dataLayerPromise(payload);
      else window.dataLayer?.push(payload);
    } catch (_) {}
  }

  _pushViewEvent() {
    try {
      const sectionTitle = this._getTriggerProductTitle();
      const isBundle = this._currentKey === this.bundleKey;

      if (isBundle) {
        const payload = {
          event: 'cross_sell_popup_makeup_interaction',
          section: sectionTitle || '',
          interaction_type: 'view',
        };
        if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
        else window.dataLayer?.push(payload);
        return;
      }

      const offered = this._getOfferedProductTitlesList();
      const payload = {
        event: 'cross_sell_popup_interaction',
        section: sectionTitle || '',
        element_value: offered || '',
        interaction_type: 'view',
      };
      if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
      else window.dataLayer?.push(payload);
    } catch (_) {}
  }

  _formatCountdown(totalSeconds) {
    const sec = Math.max(0, Math.floor(totalSeconds));
    const mm = String(Math.floor(sec / 60)).padStart(2, '0');
    const ss = String(sec % 60).padStart(2, '0');
    return `${mm}m ${ss}s`;
  }

  _getSingleOfferTitle(btn) {
    try {
      const idx = Number(btn?.getAttribute('data-product-index') || 0);
      const items = this._getStoredGroupBItems();
      const title = items?.[idx]?.title;
      if (title) return String(title);
    } catch (_) {}
    try {
      const titleEl = btn?.closest('.xs-offer')?.querySelector('.title');
      if (titleEl?.textContent) return titleEl.textContent.trim();
    } catch (_) {}
    return '';
  }

  _getBundleOfferTitles() {
    try {
      const items = this._getStoredGroupBItems();
      const t1 = items?.[0]?.title ? String(items[0].title) : '';
      const t2 = items?.[1]?.title ? String(items[1].title) : '';
      return [t1, t2].filter(Boolean).join(', ');
    } catch (_) {}
    try {
      const titles = Array.from(this.$body.querySelectorAll('.xs-card .title'))
        .map((el) => el.textContent?.trim())
        .filter(Boolean);
      return titles.join(', ');
    } catch (_) {}
    return '';
  }

  _pushAddEvent(elementValue) {
    try {
      const payload = {
        event: 'cross_sell_popup_interaction',
        section: this._getTriggerProductTitle() || '',
        element: 'add_to_cart_button',
        element_value: elementValue || '',
        interaction_type: 'click',
      };
      if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
      else window.dataLayer?.push(payload);
    } catch (_) {}
  }

  async _pushBundleCreateClick() {
    try {
      const payload = {
        event: 'cross_sell_popup_makeup_interaction',
        section: this._getTriggerProductTitle() || '',
        element: 'create_bundle_button',
        interaction_type: 'click',
      };
      if (typeof dataLayerPromise === 'function') await dataLayerPromise(payload);
      else window.dataLayer?.push(payload);
    } catch (_) {}
  }

  _startCountdown(targetEl, expireAt, onExpire) {
    if (!targetEl || !Number.isFinite(expireAt)) return;

    this._stopCountdownFor(targetEl);

    const tick = () => {
      const remain = Math.floor((expireAt - Date.now()) / 1000);
      if (remain <= 0) {
        targetEl.textContent = '00:00';
        this._stopCountdownFor(targetEl);
        try {
          onExpire?.();
        } catch (_) {}
        return;
      }
      targetEl.textContent = this._formatCountdown(remain);
    };

    tick();
    const id = setInterval(tick, 1000);

    this._countdowns.set(targetEl, { id, onExpire: onExpire || null });
  }

  _stopCountdownFor(targetEl) {
    const rec = targetEl ? this._countdowns.get(targetEl) : null;
    if (rec && rec.id) clearInterval(rec.id);
    if (targetEl) this._countdowns.delete(targetEl);
  }

  _clearAllCountdowns() {
    for (const { id } of this._countdowns.values()) {
      clearInterval(id);
    }
    this._countdowns.clear();
  }

  _getPendingExpireAt() {
    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    if (!Number.isFinite(expireAt) || expireAt <= Date.now()) return null;
    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';

    if (pending || shown) return expireAt;
    return null;
  }

  _formatOfferTitlesForCta() {
    try {
      const items = this._getStoredGroupBItems();
      const t1 = items?.[0]?.title ? String(items[0].title) : '';
      const t2 = items?.[1]?.title ? String(items[1].title) : '';
      if (t1 && t2) return `${t1} i ${t2}`;
      if (t1) return t1;
      if (t2) return t2;
    } catch (_) {}
    return '';
  }

  _pushCartCtaEvent() {
    try {
      const expireAt = this._lastExpireAt || Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
      const remain = Math.max(0, Math.floor((expireAt - Date.now()) / 1000));
      const remainingStr = this._formatCountdown(remain);
      const offeredTitles = this._formatOfferTitlesForCta();

      const payload = {
        event: 'cross_sell_section_clicked',
        section: 'shopping_basket',
        element: remainingStr,
        element_value: offeredTitles,
        interaction_type: 'click',
      };
      if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
      else window.dataLayer?.push(payload);
    } catch (_) {}
  }

  _clearRedirectSchedule() {
    try {
      localStorage.removeItem('yk_xsell_redirect_active');
      localStorage.removeItem('yk_xsell_redirect_key');
      localStorage.removeItem('yk_xsell_redirect_fire_at');
    } catch (_) {}
    if (this._redirectTimer) {
      clearTimeout(this._redirectTimer);
      this._redirectTimer = null;
    }
  }

  _armRedirectWatcher() {
    try {
      if (this._isHardClosed()) {
        this._clearRedirectSchedule();
        return;
      }
      const active = localStorage.getItem('yk_xsell_redirect_active') === '1';
      if (!active) return;

      const openedFromCart = localStorage.getItem('yk_xsell_opened_from_cart') === '1';
      if (openedFromCart) {
        this._clearRedirectSchedule();
        return;
      }

      const key = (localStorage.getItem('yk_xsell_redirect_key') || '').trim().toLowerCase();
      const fireAt = Number(localStorage.getItem('yk_xsell_redirect_fire_at') || 0);
      if (!key || !Number.isFinite(fireAt)) {
        this._clearRedirectSchedule();
        return;
      }

      const delay = Math.max(0, fireAt - Date.now());
      this._redirectTimer = setTimeout(() => {
        const isOpen = !!this.$modal && this.$modal.classList.contains('active');
        if (!isOpen) {
          this.openWithKey(key, { force: true });
        }
        this._clearRedirectSchedule();
      }, delay);
    } catch (_) {}
  }

  _suspendGroupBOnTriggerRemoved() {
    try {
      localStorage.removeItem('yk_xsell_groupB_pending');
      localStorage.removeItem('yk_xsell_groupB_items');

      localStorage.setItem('yk_xsell_groupB_shown', '1');
      localStorage.setItem('yk_xsell_groupB_shown_ts', String(Date.now()));
      localStorage.removeItem('yk_xsell_opened_from_cart');
    } catch (_) {}
    this._hideCartCtaNow();
  }
}

customElements.define('yk-cross-sell-popup', YKCrossSellPopup);

function _setReopenMode() {
  try {
    localStorage.setItem('yk_xsell_reopen_mode', '1');
  } catch (_) {}
}
function _isReopenMode() {
  try {
    return localStorage.getItem('yk_xsell_reopen_mode') === '1';
  } catch (_) {
    return false;
  }
}
function _clearReopenMode() {
  try {
    localStorage.removeItem('yk_xsell_reopen_mode');
  } catch (_) {}
}

function getVariantId(item) {
  return Number(item?.variant_id ?? item?.product_variant_id ?? item?.variant?.id ?? 0);
}

function getLineKey(item) {
  return String(item?.key ?? item?.id ?? getVariantId(item) ?? '');
}

function isPromoItem(it) {
  return !!(it?.properties?._yk_xsell_link || it?.properties?._yk_xsell_bundle === '1');
}

function getPromoLinkId(it) {
  return Number(it?.properties?._yk_xsell_link || 0);
}

function getItemName(it) {
  return it?.product_title || it?.title || '';
}

function pushCrossSellRemovedEvent(productName) {
  try {
    const payload = {
      event: 'cross_sell_product_removed',
      section: 'shopping_basket',
      element: String(productName || ''),
    };
    if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
    else window.dataLayer?.push(payload);
  } catch (_) {}
}

function pushOriginalRemovedEvent(productName) {
  try {
    const payload = {
      event: 'cross_sell_original_product_removed',
      section: 'shopping_basket',
      element_value: String(productName || ''),
    };
    if (typeof dataLayerPromise === 'function') dataLayerPromise(payload);
    else window.dataLayer?.push(payload);
  } catch (_) {}
}

let _prevCartSnapshot = null;
let _promoAutoCleanup = false;
let _removeItemPatched = false;

function _snapshotCartItems() {
  try {
    const items = Rebuy?.SmartCart?.cart?.items || [];
    return items.map((it) => ({
      lineKey: getLineKey(it),
      variantId: getVariantId(it),
      product_title: getItemName(it),
      isPromo: isPromoItem(it),
      promoLinkId: getPromoLinkId(it),
      quantity: Number(it?.quantity || 1),
      isBundle: it?.properties?._yk_xsell_bundle === '1',
      bundleGroup: it?.properties?._yk_xsell_bundle_group || null,
    }));
  } catch (_) {
    return [];
  }
}

function _getQtyByVariant(items, variantId) {
  try {
    return (items || [])
      .filter((it) => !it.isPromo && it.variantId === Number(variantId))
      .reduce((n, it) => n + Number(it.quantity || 1), 0);
  } catch (_) {
    return 0;
  }
}

function maybeReopenXsellPopup(prevItems, currItems) {
  return;
  try {
    const pending = localStorage.getItem('yk_xsell_groupB_pending') === '1';
    if (!pending) return;

    const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
    if (!shown) return;

    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    if (!Number.isFinite(expireAt) || Date.now() >= expireAt) return;

    const lastKey = localStorage.getItem('yk_xsell_groupB_lastkey') || '';
    if (!lastKey) return;

    const linkVid = Number(localStorage.getItem('yk_xsell_groupB_link') || 0);
    if (!Number.isFinite(linkVid) || linkVid <= 0) return;

    const prevQty = _getQtyByVariant(prevItems, linkVid);
    const currQty = _getQtyByVariant(currItems, linkVid);

    if (prevQty === 0 && currQty > 0) {
      const popup = document.querySelector('yk-cross-sell-popup');
      _clearReopenMode();
      popup?.openWithKey(lastKey, { force: true });
    }
  } catch (e) {
    console.warn('maybeReopenXsellPopup error', e);
  }
}

function maybeRestorePendingCta() {
  try {
    if (_isReopenMode()) return;
    const items = Rebuy?.SmartCart?.cart?.items || [];

    const lastKey = localStorage.getItem('yk_xsell_groupB_lastkey') || '';
    const expireAt = Number(localStorage.getItem('yk_xsell_groupB_expire_at') || 0);
    const notExpired = Number.isFinite(expireAt) && expireAt > Date.now();

    if (!lastKey || !notExpired) return;

    if (localStorage.getItem('yk_xsell_groupB_pending') === '1') return;

    const shown = localStorage.getItem('yk_xsell_groupB_shown') === '1';
    if (!shown) return;

    const linkVid = Number(localStorage.getItem('yk_xsell_groupB_link') || 0);
    if (!Number.isFinite(linkVid) || linkVid <= 0) return;

    const hasTrigger = items.some((it) => !isPromoItem(it) && getVariantId(it) === linkVid);
    if (!hasTrigger) return;

    const hasPromoForLink = items.some((it) => isPromoItem(it) && getPromoLinkId(it) === linkVid);
    if (hasPromoForLink) return;

    localStorage.setItem('yk_xsell_groupB_pending', '1');
    localStorage.removeItem('yk_xsell_groupB_shown');

    const popup = document.querySelector('yk-cross-sell-popup');
    popup?._onSmartcartReady();
  } catch (e) {
    console.warn('maybeRestorePendingCta error', e);
  }
}

function _ensureInitialSnapshot() {
  if (!_prevCartSnapshot) {
    _prevCartSnapshot = _snapshotCartItems();
  }
}

function trackRemoveEvents() {
  const curr = _snapshotCartItems();
  if (_prevCartSnapshot) {
    try {
      maybeReopenXsellPopup(_prevCartSnapshot, curr);
    } catch (e) {
      console.warn(e);
    }
  } else {
    _prevCartSnapshot = curr;
    return;
  }

  const prevTriggerQty = new Map();
  const prevPromosByLink = new Map();
  const prevPromoQty = new Map();
  const prevPromoNameByLine = new Map();
  const prevPromoLines = new Set();

  for (const it of _prevCartSnapshot) {
    if (it.isPromo) {
      prevPromoQty.set(it.lineKey, (prevPromoQty.get(it.lineKey) || 0) + it.quantity);
      prevPromoLines.add(it.lineKey);
      if (it.product_title) prevPromoNameByLine.set(it.lineKey, it.product_title);
      if (it.promoLinkId)
        prevPromosByLink.set(it.promoLinkId, (prevPromosByLink.get(it.promoLinkId) || 0) + it.quantity);
      continue;
    }
    prevTriggerQty.set(it.variantId, (prevTriggerQty.get(it.variantId) || 0) + it.quantity);
  }

  const currTriggerQty = new Map();
  const currPromoQty = new Map();
  const currPromoLines = new Set();

  for (const it of curr) {
    if (it.isPromo) {
      currPromoQty.set(it.lineKey, (currPromoQty.get(it.lineKey) || 0) + it.quantity);
      currPromoLines.add(it.lineKey);
    } else {
      currTriggerQty.set(it.variantId, (currTriggerQty.get(it.variantId) || 0) + it.quantity);
    }
  }

  for (const [variantId, prevQty] of prevTriggerQty.entries()) {
    const nowQty = currTriggerQty.get(variantId) || 0;

    if (prevQty > 0 && nowQty === 0) {
      const name = _prevCartSnapshot.find((x) => !x.isPromo && x.variantId === variantId)?.product_title || '';
      pushOriginalRemovedEvent(name);

      _setReopenMode();

      try {
        const popup = document.querySelector('yk-cross-sell-popup');
        popup?._suspendGroupBOnTriggerRemoved();
      } catch (e) {
        console.warn('suspend on trigger removed failed', e);
      }
    }
  }

  if (!_removeItemPatched && !_promoAutoCleanup) {
    for (const lineKey of prevPromoLines) {
      if (!currPromoLines.has(lineKey)) {
        const name = prevPromoNameByLine.get(lineKey) || '';
        pushCrossSellRemovedEvent(name);
      } else {
        const prevQ = prevPromoQty.get(lineKey) || 0;
        const nowQ = currPromoQty.get(lineKey) || 0;
        if (nowQ < prevQ) {
          const name = prevPromoNameByLine.get(lineKey) || '';
          pushCrossSellRemovedEvent(name);
        }
      }
    }
  }

  _prevCartSnapshot = curr;
}

async function removeDiscountedOrphans() {
  try {
    _promoAutoCleanup = true;
    const items = Rebuy?.SmartCart?.cart?.items || [];

    const triggerQty = new Map();
    for (const it of items) {
      if (isPromoItem(it)) continue;
      const vId = getVariantId(it);
      if (!Number.isFinite(vId) || vId <= 0) continue;
      triggerQty.set(vId, (triggerQty.get(vId) || 0) + Number(it.quantity || 1));
    }

    const promosByLink = new Map();
    for (const it of items) {
      const linkId = getPromoLinkId(it);
      if (!linkId) continue;
      if (!promosByLink.has(linkId)) promosByLink.set(linkId, []);
      promosByLink.get(linkId).push(it);
    }

    for (const [linkId, promoItems] of promosByLink.entries()) {
      const qtyOfTrigger = triggerQty.get(linkId) || 0;

      if (qtyOfTrigger <= 0) {
        for (const promo of promoItems) {
          try {
            const name = getItemName(promo);
            await Rebuy.SmartCart.removeItem(promo);
            pushCrossSellRemovedEvent(name);
          } catch (e) {
            console.warn(e);
          }
        }
        try {
          const popup = document.querySelector('yk-cross-sell-popup');
          popup?._suspendGroupBOnTriggerRemoved();
        } catch (e) {
          console.warn(e);
        }
        _setReopenMode();
        continue;
      }

      const multipliers = promoItems.map((it) => (it?.properties?._yk_xsell_bundle === '1' ? 2 : 1));
      const maxAllowed = qtyOfTrigger * Math.max(...multipliers);

      const totalPromoQty = promoItems.reduce((acc, it) => acc + Number(it.quantity || 1), 0);
      let toRemoveQty = Math.max(0, totalPromoQty - maxAllowed);

      if (toRemoveQty > 0) {
        for (const promo of [...promoItems].reverse()) {
          if (toRemoveQty <= 0) break;
          const q = Number(promo.quantity || 1);
          try {
            const name = getItemName(promo);
            await Rebuy.SmartCart.removeItem(promo);
            pushCrossSellRemovedEvent(name);
          } catch (e) {
            console.warn(e);
          }
          toRemoveQty -= q;
        }
      }
    }

    const bundleGroups = new Map();
    for (const it of items) {
      if (it?.properties?._yk_xsell_bundle !== '1') continue;
      const gid = it?.properties?._yk_xsell_bundle_group;
      if (!gid) continue;
      if (!bundleGroups.has(gid)) bundleGroups.set(gid, []);
      bundleGroups.get(gid).push(it);
    }

    for (const [gid, groupItems] of bundleGroups.entries()) {
      const groupCount = groupItems.reduce((n, it) => n + Number(it.quantity || 1), 0);
      const expected = 2;
      if (groupCount > 0 && groupCount < expected) {
        for (const promo of groupItems) {
          try {
            const name = getItemName(promo);
            await Rebuy.SmartCart.removeItem(promo);
            pushCrossSellRemovedEvent(name);
          } catch (e) {
            console.warn(e);
          }
        }
      }
    }
  } catch (err) {
    console.warn('removeDiscountedOrphans error', err);
  } finally {
    _promoAutoCleanup = false;
  }
}

function hideCtaIfTriggerGone() {
  const wrap = document.getElementById('yk-xsell-pending-cta');
  if (!wrap) return;

  const triggerVid = Number(wrap.getAttribute('data-trigger-vid') || 0);
  if (!Number.isFinite(triggerVid) || triggerVid <= 0) return;

  const items = Rebuy?.SmartCart?.cart?.items || [];
  const hasTrigger = items.some((it) => getVariantId(it) === triggerVid);

  if (!hasTrigger) {
    const popup = document.querySelector('yk-cross-sell-popup');
    popup?._hideCartCtaNow();
    popup?._suspendGroupBOnTriggerRemoved();
    _setReopenMode();
  }
}

async function scheduleCleanup() {
  await removeDiscountedOrphans();
  setTimeout(() => {
    hideCtaIfTriggerGone();
    maybeRestorePendingCta();
  }, 300);
}

function _patchRemoveItemOnce() {
  try {
    const SC = Rebuy?.SmartCart;
    if (!SC || !SC.removeItem || _removeItemPatched) return;

    const orig = SC.removeItem.bind(SC);
    SC.removeItem = async function patchedRemoveItem(item, ...rest) {
      const name = getItemName(item);
      const promo = isPromoItem(item);

      const result = await orig(item, ...rest);

      try {
        if (promo && !_promoAutoCleanup) {
          pushCrossSellRemovedEvent(name);
        }
      } catch (e) {
        console.warn(e);
      }

      return result;
    };

    _removeItemPatched = true;
  } catch (e) {
    console.warn('[XSell] patch removeItem failed', e);
  }
}

document.addEventListener('rebuy:ready', () => {
  _patchRemoveItemOnce();
  _ensureInitialSnapshot();
});

document.addEventListener('rebuy:smartcart.show', () => {
  _patchRemoveItemOnce();
  _ensureInitialSnapshot();
  setTimeout(scheduleCleanup, 300);
});

document.addEventListener('rebuy:cart.change', () => {
  try {
    _patchRemoveItemOnce();
    trackRemoveEvents();
  } catch (e) {
    console.warn(e);
  }
  setTimeout(scheduleCleanup, 300);
});
